// Game configuration and physics constants (V3 - Approved)

export const GAME_CONFIG = {
  WIDTH: 320,
  HEIGHT: 200,
  SCALE: 3,
  TILE_SIZE: 16,
} as const;

export const PHYSICS = {
  // Fixed timestep
  TICK_RATE: 60,
  FIXED_DT: 1000 / 60, // ~16.67ms

  // Movement - balanced snappy/floaty (Keen 4/5/6 feel)
  MAX_SPEED: 165,
  ACCELERATION: 1300,
  GROUND_FRICTION: 1200,
  AIR_FRICTION: 120,

  // Jumping - tighter arc
  // Max jump: 48.9px (~3 tiles), Time to apex: 0.326s
  JUMP_VELOCITY: -300,
  GRAVITY: 920,
  MAX_FALL_SPEED: 380,

  // Feel adjustments (in milliseconds for frame-independence)
  COYOTE_TIME_MS: 83,    // 5 frames at 60fps
  JUMP_BUFFER_MS: 100,   // 6 frames at 60fps
  VARIABLE_JUMP_MULTIPLIER: 0.48,

  // Pogo stick
  POGO_VELOCITY: -380,
} as const;

export const COLORS = {
  SKY: 0x1a1a2e,
  GROUND: 0x4a4a6a,
  PLAYER: 0x00ff88,
  ENEMY: 0xff4444,
  COLLECTIBLE: 0xffff00,
} as const;
